import React from 'react';
import { useOfferContext } from '../../../../context';
import { ContentRow } from '../../../../components/ContentRow';
import { Label } from '../../../../components/Label';
import { AgentBankLabel } from '../../../../components/AgentBankLabel';

export function AgentBuildersLabelContainer() {
  const { agentBuildersLabel, isFromBank } = useOfferContext();

  if (!agentBuildersLabel) {
    return null;
  }

  return (
    <ContentRow>{isFromBank ? <AgentBankLabel /> : <Label text={agentBuildersLabel} theme="success" />}</ContentRow>
  );
}
